package helpers

import react.router.useLoaderData

/**
 * Проверка на существование объекта ([undefined]) и не NULL
 *
 * @return [T] - возвращает [defaultValue] или полученное значение
 */
fun <T> T?.takeIfNotUndefined(
    defaultValue: T
): T {
    val ll =  this?.let { kk->
        kk.takeIf { gg-> gg != undefined}.unsafeCast<T>() ?: defaultValue
    } ?: defaultValue

    return ll
}

/**
 * Проверка на существование объекта ([undefined])
 *
 * @return [T] - возвращает [defaultValue] или NULL
 */
fun <T> T?.takeIfNotUndefined(): T? {
    val ll = this?.let { kk->
        kk.takeIf { gg-> gg != undefined}.unsafeCast<T>()
    }

    return ll
}

/**
 * Получение значения из лоадера или NULL
 */
inline fun <reified R> getFromLoader (): R?{
    val loadData = useLoaderData()
    return try { loadData as? R }catch (_: Exception){null}
}

/**
 * Получение значения из лоадера или [defaultValue]
 */
inline fun <reified R> getFromLoader (
    defaultValue: R
): R{
    val loadData = useLoaderData()
    return try { loadData as R }catch (_: Exception){defaultValue}
}